import { useParams, useNavigate } from 'react-router-dom';
import ChatScreen from '@/components/ChatScreen';
import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

const ChatPage = () => {
  const { id: chatId } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const [otherUser, setOtherUser] = useState<{ name: string; avatar?: string } | null>(null);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    const fetchOtherUser = async () => {
      if (!chatId || !user) return;
      
      try {
        // Get chat to find other user
        const { data: chat } = await supabase
          .from('chats')
          .select('user1_id, user2_id')
          .eq('id', chatId)
          .single();
        
        if (!chat) return;
        
        // Determine other user ID
        const otherUserId = chat.user1_id === user.id ? chat.user2_id : chat.user1_id;
        
        // Get other user profile
        const { data: profile } = await supabase
          .from('profiles')
          .select('full_name, avatar_url')
          .eq('user_id', otherUserId)
          .single();
        
        setOtherUser({
          name: profile?.full_name || 'Usuario',
          avatar: profile?.avatar_url
        });
      } catch (error) {
        console.error('Error fetching other user:', error);
      } finally {
        setLoading(false);
      }
    };
    
    fetchOtherUser();
  }, [chatId, user]);
  
  const handleBack = () => {
    navigate(-1);
  };

  if (loading || !otherUser) {
    return (
      <div className="h-[100dvh] bg-gradient-to-br from-[#1b3521] via-[#31633f] to-[#6da079] flex items-center justify-center">
        <div className="animate-spin h-8 w-8 border-4 border-white border-t-transparent rounded-full"></div>
      </div>
    );
  }

  return (
    <div className="h-[100dvh] bg-gradient-to-br from-[#1b3521] via-[#31633f] to-[#6da079] overflow-hidden">
      <ChatScreen
        chatId={chatId || ''}
        partnerName={otherUser.name}
        partnerAvatar={otherUser.avatar}
        onBack={handleBack}
      />
    </div>
  );
};

export default ChatPage;